import { expect } from 'chai';
import * as StringUtils from '@oracle/oraclejet-preact/utils/stringUtils';

describe('Test StringUtils', () => {
  it('isEmpty', function () {
    // null
    expect(StringUtils.isEmpty(null)).to.be.true;

    // string
    expect(StringUtils.isEmpty('')).to.be.true;
    expect(StringUtils.isEmpty('     ')).to.be.true;
    expect(StringUtils.isEmpty('foo')).to.be.false;

    // object
    expect(StringUtils.isEmpty({})).to.be.true;
    expect(StringUtils.isEmpty({ foo: 'bar' })).to.be.true;
    expect(StringUtils.isEmpty([])).to.be.true;
    expect(StringUtils.isEmpty([ 'foo' ])).to.be.false;
  });

  it('isEmptyOrUndefined', function () {
    // undefined
    expect(StringUtils.isEmptyOrUndefined(undefined)).to.be.true;

    // null
    expect(StringUtils.isEmptyOrUndefined(null)).to.be.true;

    // string
    expect(StringUtils.isEmptyOrUndefined('')).to.be.true;
    expect(StringUtils.isEmptyOrUndefined('     ')).to.be.true;
    expect(StringUtils.isEmptyOrUndefined('foo')).to.be.false;

    // object
    expect(StringUtils.isEmptyOrUndefined({})).to.be.true;
    expect(StringUtils.isEmptyOrUndefined({ foo: 'bar' })).to.be.true;
    expect(StringUtils.isEmptyOrUndefined([])).to.be.true;
    expect(StringUtils.isEmptyOrUndefined([ 'foo' ])).to.be.false;
  });

  it('isString', function () {
    // null
    expect(StringUtils.isString(null)).to.be.false;

    // string
    expect(StringUtils.isString('')).to.be.true;
    expect(StringUtils.isString('     ')).to.be.true;
    expect(StringUtils.isString('foo')).to.be.true;

    // object
    expect(StringUtils.isString({})).to.be.false;
    expect(StringUtils.isString({ foo: 'bar' })).to.be.false;
    expect(StringUtils.isString([])).to.be.false;
    expect(StringUtils.isString([ 'foo' ])).to.be.false;
    expect(StringUtils.isString(new String('foo'))).to.be.true;
  });

  it('trim', function () {
    let str:any;

    // null
    expect(StringUtils.trim(null)).null;

    // string
    str = '';
    expect(StringUtils.trim(str)).equal(str);
    expect(StringUtils.trim('     ')).equal(str);
    str = 'foo';
    expect(StringUtils.trim(str)).equal(str);
    expect(StringUtils.trim('  foo  ')).equal(str);

    // object
    str = {};
    expect(StringUtils.trim(str)).equal(str);
    str = { foo: 'bar' };
    expect(StringUtils.trim(str)).equal(str);
    str = [];
    expect(StringUtils.trim(str)).equal(str);
    str = [ 'foo' ];
    expect(StringUtils.trim(str)).equal(str);
    str = new String('  foo  ');
    expect(StringUtils.trim(str)).equal('foo');
  });

  it('hashCode', function () {
    const hash1 = StringUtils.hashCode('foo');
    const hash2 = StringUtils.hashCode('bar');
    expect(typeof hash1).equal('number');
    expect(typeof hash2).equal('number');
    expect(hash1).not.equal(hash2);
    expect(StringUtils.hashCode('foo')).equal(hash1);
  });
});
